import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const LOGO_URL = "/images/logo.png";

const navLinks = [
  { path: "/", label: "Accueil" },
  { path: "/reparation", label: "Réparation" },
  { path: "/accessoires", label: "Accessoires" },
  { path: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || isMobileOpen
          ? "bg-white shadow-sm"
          : "bg-transparent"
      }`}
    >
      <nav className="flex items-center justify-between px-4 md:px-8 py-5 max-w-7xl mx-auto">
        <Link
          to="/"
          className="flex items-center transition-all"
        >
          <img
            src={LOGO_URL}
            alt="OYA PHONE"
            className={`h-12 md:h-14 w-auto object-contain transition-all duration-300 ${
              isScrolled ? "" : "drop-shadow-[0_2px_8px_rgba(0,0,0,0.6)]"
            }`}
          />
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-sm font-medium transition-colors relative group ${
                location.pathname === link.path
                  ? isScrolled
                    ? "text-oya-red"
                    : "text-oya-red-light"
                  : isScrolled
                  ? "text-oya-black hover:text-oya-red"
                  : "text-white/90 hover:text-white"
              }`}
            >
              {link.label}
              <span
                className={`absolute -bottom-1 left-0 h-0.5 transition-all duration-300 ${
                  location.pathname === link.path ? "w-full" : "w-0 group-hover:w-full"
                } ${isScrolled ? "bg-oya-red" : "bg-white"}`}
              />
            </Link>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-4">
          <a
            href="tel:0651004790"
            className={`flex items-center gap-2 text-sm font-medium px-4 py-2 rounded-full border transition-all ${
              isScrolled
                ? "border-oya-black text-oya-black hover:bg-oya-black hover:text-white"
                : "border-white/60 text-white hover:bg-white hover:text-oya-black"
            }`}
          >
            <i className="ri-phone-line" />
            <span className="hidden lg:inline">06 51 00 47 90</span>
          </a>
        </div>

        <button
          type="button"
          onClick={() => setIsMobileOpen(!isMobileOpen)}
          className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors ${
            isScrolled || isMobileOpen ? "text-oya-black" : "text-white"
          }`}
          aria-label="Menu"
        >
          {isMobileOpen ? <i className="ri-close-line text-2xl" /> : <i className="ri-menu-line text-2xl" />}
        </button>
      </nav>

      {isMobileOpen && (
        <div className="md:hidden bg-white border-t border-oya-gray-light animate-slide-down">
          <div className="flex flex-col px-4 py-4 gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                  location.pathname === link.path
                    ? "bg-oya-red/10 text-oya-red"
                    : "text-oya-black hover:bg-oya-gray-light"
                }`}
              >
                {link.label}
              </Link>
            ))}
            <a
              href="tel:0651004790"
              className="flex items-center gap-2 px-4 py-3 rounded-lg text-sm font-medium text-oya-red bg-oya-red/10 mt-2"
            >
              <i className="ri-phone-line" />
              06 51 00 47 90
            </a>
          </div>
        </div>
      )}
    </header>
  );
}